<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="topBox flex">
      <div class="topLeft flex" style="align-items: center; flex-wrap: wrap">
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">订单号：</span>
          <div style="width: 220px">
            <el-input v-model="query.orderNo" placeholder="模糊查询" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">买家昵称：</span>
          <div style="width: 150px">
            <el-input v-model="query.buyerNickName" placeholder="可选" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">卖家昵称：</span>
          <div style="width: 150px">
            <el-input v-model="query.sellerNickName" placeholder="可选" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">阶段：</span>
          <div style="width: 160px">
            <el-select v-model="query.status" placeholder="全部" clearable @change="searchFn">
              <el-option v-for="o in statusOptions" :key="String(o.value)" :label="o.label" :value="o.value" />
            </el-select>
          </div>
        </div>

        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <el-checkbox v-model="query.platformUserAppealedOnly" @change="searchFn">已向平台申诉（原案）</el-checkbox>
        </div>

        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
      </div>
    </div>

    <el-table :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
      <el-table-column prop="orderNo" label="订单号" min-width="170" align="center" show-overflow-tooltip />
      <el-table-column label="商品图" width="88" align="center">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.productImage"
            class="productThumb"
            :src="scope.row.productImage"
            fit="cover"
            :preview-src-list="[scope.row.productImage]"
          />
          <span v-else class="productThumbPlaceholder">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="productTitle" label="商品标题" min-width="220" show-overflow-tooltip />

      <el-table-column label="买家" width="160" align="center">
        <template slot-scope="scope">
          <div class="userCell">
            <img v-if="scope.row.buyerPhoto" :src="scope.row.buyerPhoto" class="userAvatar" />
            <span class="userName">{{ scope.row.buyerNickName || "-" }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="卖家" width="160" align="center">
        <template slot-scope="scope">
          <div class="userCell">
            <img v-if="scope.row.sellerPhoto" :src="scope.row.sellerPhoto" class="userAvatar" />
            <span class="userName">{{ scope.row.sellerNickName || "-" }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="阶段" width="148" align="center">
        <template slot-scope="scope">
          <span :style="{ color: statusColor(scope.row.status) }">{{ disputeStatusCell(scope.row) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="票况" min-width="150" align="center">
        <template slot-scope="scope">
          <div
            v-if="scope.row.voteBuyerCount != null"
            class="voteTallyCell"
            :title="scope.row.voteVersusHint || ''"
          >
            <div class="voteTallyNums">
              <span class="voteTallyB">买{{ scope.row.voteBuyerCount }}</span>
              <span class="voteTallySep">·</span>
              <span class="voteTallyS">卖{{ scope.row.voteSellerCount }}</span>
              <span class="voteTallySep">·</span>
              <span class="voteTallyA">弃{{ scope.row.voteAbstainCount }}</span>
            </div>
            <div
              v-if="scope.row.voteEndAt"
              class="voteTallySub"
              :class="{ 'voteTallySub--urgent': scope.row.voteDeadlineUrgent }"
            >
              截止 {{ formatTime(scope.row.voteEndAt) }}
            </div>
          </div>
          <div v-else-if="scope.row.voteVersusHint" class="voteTallyHint" :title="scope.row.voteVersusHint">
            {{ scope.row.voteVersusHint }}
          </div>
          <span v-else class="voteTallyDash">—</span>
        </template>
      </el-table-column>

      <el-table-column label="平台申诉" width="108" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.platformUserAppealedAt" type="warning" size="mini">已申诉</el-tag>
          <span v-else class="voteTallyDash">—</span>
        </template>
      </el-table-column>

      <el-table-column label="举证截止" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.evidenceEndAt) }}</template>
      </el-table-column>

      <el-table-column label="裁定/结果" min-width="220" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status === 3 || scope.row.status === 4 || scope.row.status === -1">
            <template v-if="scope.row.status === -1">{{ scope.row.resolveChannel || "—" }}</template>
            <template v-else>{{ scope.row.platformDecision || scope.row.finalWinner || "-" }}</template>
            <span v-if="scope.row.platformRemark">：{{ scope.row.platformRemark }}</span>
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="创建时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>

      <el-table-column label="操作" width="172" align="center" fixed="right" class-name="col-actions">
        <template slot-scope="scope">
          <div class="actionStack">
            <el-button class="actionBtnFull" size="mini" @click="openCaseDetail(scope.row)">案件详情</el-button>
            <template v-if="scope.row.status === 3 && scope.row.platformUserAppealedAt">
              <el-button
                class="actionBtnFull"
                size="mini"
                type="danger"
                plain
                @click="openPlatformVerdict(scope.row, 'appealReview')"
              >
                申诉复核改判
              </el-button>
            </template>
            <template v-else-if="scope.row.status === 2">
              <el-button class="actionBtnFull actionBtnSnap" size="mini" type="primary" plain @click="openVoteSnapshot(scope.row)">
                票况/结果
              </el-button>
              <el-button class="actionBtnFull" size="mini" @click="openSockVote(scope.row)">马甲投票</el-button>
              <el-button class="actionBtnFull" size="mini" type="warning" plain @click="openPlatformVerdict(scope.row, 'forceJury')">
                平台裁定
              </el-button>
            </template>
            <template v-else-if="scope.row.status === 1 || scope.row.status === 5">
              <el-button class="actionBtnFull" size="mini" type="primary" plain @click="openPlatformVerdict(scope.row, 'simple')">平台简易裁</el-button>
              <el-button
                v-if="scope.row.status === 5"
                class="actionBtnFull"
                size="mini"
                type="warning"
                plain
                :loading="transferToJuryRowId === scope.row.caseId"
                @click="submitTransferToJury(scope.row.caseId, 'row')"
              >流转小法庭</el-button>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="马甲替投" :visible.sync="sockDialogVisible" width="480px">
      <div v-loading="sockPuppetsLoading" class="sockDialogInner">
        <el-alert
          v-if="sockPuppetPickHint"
          :title="sockPuppetPickHint"
          :type="sockPuppetVotable ? 'info' : 'warning'"
          show-icon
          :closable="false"
          class="sockPickAlert"
        />
        <div v-if="sockPuppetRoundMeta" class="sockRoundMeta">{{ sockPuppetRoundMeta }}</div>

        <div v-if="sockPuppetsVoted.length" class="sockVotedBlock">
          <div class="sockVotedTitle">本纠纷当前投票轮 · 已投票马甲（{{ sockPuppetsVoted.length }}）</div>
          <div class="sockVotedList">
            <div v-for="r in sockPuppetsVoted" :key="'vd' + r.sockPuppetId + '_' + (r.votedAt || '')" class="sockVotedRow">
              <img v-if="r.avatarUrl" :src="r.avatarUrl" class="sockVotedAvatar" alt="" />
              <div v-else class="sockVotedAvatar sockVotedAvatar--ph">{{ (r.nickName || "马").charAt(0) }}</div>
              <div class="sockVotedMeta">
                <div class="sockVotedName">{{ (r.nickName || "马甲").trim() || "马甲" }}</div>
                <div class="sockVotedSub">
                  {{ r.choiceLabel || "—" }}<span v-if="r.reasonTag"> · {{ r.reasonTag }}</span>
                </div>
                <div v-if="r.reasonDetail" class="sockVotedDetail">{{ r.reasonDetail }}</div>
                <div class="sockVotedTime">{{ formatTime(r.votedAt) }}</div>
              </div>
            </div>
          </div>
        </div>

        <el-form v-if="sockPuppetVotable" label-width="100px" size="small" class="sockVoteForm">
          <el-form-item label="可选马甲" required>
            <el-input
              v-model="sockPuppetFilter"
              size="small"
              clearable
              placeholder="按昵称筛选"
              prefix-icon="el-icon-search"
              style="width: 100%; margin-bottom: 6px"
            />
            <div v-if="sockPuppets.length" class="sockPuppetToolbar">
              <span class="sockPuppetHint">下列马甲可多选，所选数量不能超过本轮「还可投」名额；已投过票的马甲见上方列表</span>
              <el-button v-if="sockForm.sockPuppetIds.length" type="text" size="mini" @click="clearSockSelection">清空已选</el-button>
            </div>
            <div v-if="sockPuppets.length" class="sockPuppetCount">
              已选 {{ sockForm.sockPuppetIds.length }} 个马甲
              <span v-if="sockPuppetPickLimit != null">（本轮最多还可一次提交 {{ sockPuppetPickLimit }} 票）</span>
            </div>
            <div v-if="!sockPuppets.length" class="sockPuppetEmpty">
              {{ sockPuppetsVoted.length ? "本轮启用马甲均已投票，无可再选" : "暂无可用马甲，请先维护数据" }}
            </div>
            <div v-else class="sockPuppetList">
              <div
                v-for="p in filteredSockPuppets"
                :key="p.id"
                class="sockPuppetRow"
                :class="{ active: sockForm.sockPuppetIds.indexOf(p.id) !== -1 }"
                @click="toggleSockPuppet(p)"
              >
                <img v-if="p.avatarUrl" :src="p.avatarUrl" class="sockPuppetAvatar" alt="" />
                <div v-else class="sockPuppetAvatar sockPuppetAvatar--ph">{{ (p.nickName || "马").charAt(0) }}</div>
                <div class="sockPuppetMeta">
                  <div class="sockPuppetName">{{ (p.nickName || "马甲").trim() || "马甲" }}</div>
                </div>
              </div>
              <div v-if="sockPuppets.length && !filteredSockPuppets.length" class="sockPuppetEmpty">无匹配结果</div>
            </div>
          </el-form-item>
          <el-form-item label="立场" required>
            <el-radio-group v-model="sockForm.choice" @change="sockForm.reasonTag = ''">
              <el-radio label="BUYER">支持买家</el-radio>
              <el-radio label="SELLER">支持卖家</el-radio>
              <el-radio label="ABSTAIN">弃权</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="sockForm.choice === 'BUYER' || sockForm.choice === 'SELLER'" label="理由" required>
            <el-select v-model="sockForm.reasonTag" placeholder="请选择理由" filterable style="width: 100%">
              <el-option v-for="t in sockReasonOptions" :key="t" :label="t" :value="t" />
            </el-select>
          </el-form-item>
          <el-form-item label="补充说明">
            <el-input v-model="sockForm.reasonDetail" type="textarea" :rows="2" maxlength="2000" show-word-limit />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button size="small" @click="sockDialogVisible = false">关闭</el-button>
        <el-button
          v-if="sockPuppetVotable"
          type="primary"
          size="small"
          :loading="sockSubmitting"
          :disabled="sockPuppetsLoading"
          @click="submitSockVote"
        >
          提交投票
        </el-button>
      </span>
    </el-dialog>

    <el-dialog :title="caseDetailTitle" :visible.sync="caseDetailVisible" width="920px" top="4vh" @closed="onCaseDetailClosed">
      <div v-loading="caseDetailLoading" class="caseDetailWrap">
        <div v-if="!caseDetailLoading && !caseDetail" class="caseDetailEmpty">暂无数据</div>
        <div v-if="caseDetail && !caseDetailLoading" class="caseDetailBody">
          <div class="cd-summary">
            <div class="cd-summaryTop">
              <el-image
                v-if="caseDetail.order && caseDetail.order.productImage"
                class="cd-summaryImg"
                :src="caseDetail.order.productImage"
                fit="cover"
                :preview-src-list="[caseDetail.order.productImage]"
              />
              <div v-else class="cd-summaryImg cd-summaryImg--empty">无图</div>
              <div class="cd-summaryMain">
                <div class="cd-summaryTitleRow">
                  <div class="cd-summaryTitle">{{ (caseDetail.order && caseDetail.order.productTitle) || "—" }}</div>
                  <el-tag :type="caseDetailStatusTagType(caseDetail.status)" size="small" effect="plain">
                    {{ disputeStatusCell(caseDetail) }}
                  </el-tag>
                </div>
                <div class="cd-summarySub">订单号 {{ caseDetail.orderNo || "—" }}</div>
                <div class="cd-summaryChips">
                  <span v-if="caseDetail.order" class="cd-chip">订单 {{ secondhandOrderStatusLabel(caseDetail.order.status) }}</span>
                  <span v-if="caseDetail.refundApply" class="cd-chip cd-chip--warn">
                    {{ refundTypeLabel(caseDetail.refundApply.refundType) }} · {{ formatMoney(caseDetail.refundApply.refundAmount) }}
                  </span>
                  <span v-if="caseDetail.order && caseDetail.order.useInspection === 1" class="cd-chip">安心购</span>
                  <span v-if="caseDetail.buyerRefundSubmitCount != null" class="cd-chip">买家已申请退款 {{ caseDetail.buyerRefundSubmitCount }} 次</span>
                </div>
              </div>
            </div>
            <div class="cd-summaryParties">
              <div class="cd-party cd-party--buyer">
                <img v-if="caseDetail.buyerPhoto" :src="caseDetail.buyerPhoto" class="cd-partyAvatar" alt="" />
                <span v-else class="cd-partyAvatar cd-partyAvatar--ph">买</span>
                <span class="cd-partyName">{{ caseDetail.buyerNickName || "买家" }}</span>
              </div>
              <span class="cd-vs">VS</span>
              <div class="cd-party cd-party--seller">
                <img v-if="caseDetail.sellerPhoto" :src="caseDetail.sellerPhoto" class="cd-partyAvatar" alt="" />
                <span v-else class="cd-partyAvatar cd-partyAvatar--ph">卖</span>
                <span class="cd-partyName">{{ caseDetail.sellerNickName || "卖家" }}</span>
              </div>
            </div>
            <div v-if="caseDetail.evidenceEndAt" class="cd-summaryFoot">
              举证截止 {{ formatTime(caseDetail.evidenceEndAt) }}
              <span class="cd-dot">·</span>
              创建于 {{ formatTime(caseDetail.createTime) }}
            </div>
          </div>

          <el-alert
            v-if="caseDetail.platformUserAppealedAt"
            type="warning"
            :closable="false"
            show-icon
            class="cd-alert"
            :title="'用户已向平台申诉 · ' + formatTime(caseDetail.platformUserAppealedAt)"
          />
          <el-alert
            v-else-if="caseDetail.appealBufferEndAt"
            type="info"
            :closable="false"
            show-icon
            class="cd-alert"
            :title="'败诉方申诉截止 ' + formatTime(caseDetail.appealBufferEndAt) + '（期满未申诉将自动结案）'"
          />

          <el-collapse v-model="caseDetailCollapseActive" class="cd-collapse">
            <el-collapse-item name="timeline">
              <template slot="title">
                <span class="cd-collapseTitle">业务时间线</span>
                <span class="cd-collapseBadge">{{ (caseDetail.progressTimeline && caseDetail.progressTimeline.length) || 0 }} 步</span>
              </template>
              <div v-if="!caseDetail.progressTimeline || !caseDetail.progressTimeline.length" class="cd-empty">暂无进度记录</div>
              <div v-else class="cd-progressList">
                <div
                  v-for="(ev, idx) in caseDetail.progressTimeline"
                  :key="'pe' + idx + (ev.eventCode || '') + (ev.createTime || '')"
                  class="cd-progressItem"
                >
                  <div class="cd-progressDot" />
                  <div class="cd-progressBody">
                    <div class="cd-progressHd">
                      <span class="cd-progressTitle">{{ ev.title || ev.eventCode || "—" }}</span>
                      <span class="cd-progressRole">{{ progressOperatorLabel(ev.operatorRole) }}</span>
                      <span class="cd-progressTime">{{ formatTime(ev.createTime) }}</span>
                    </div>
                    <div v-if="ev.content" class="cd-progressContent">{{ ev.content }}</div>
                  </div>
                </div>
              </div>
            </el-collapse-item>

            <el-collapse-item name="trade">
              <template slot="title">
                <span class="cd-collapseTitle">交易与物流</span>
              </template>
              <div v-if="!caseDetail.order" class="cd-empty">暂无订单信息</div>
              <template v-else>
                <div class="cd-kvGrid cd-kvGrid--2">
                  <div class="cd-kv cd-kv--full"><span class="cd-kvLbl">商品</span><span class="cd-kvVal">{{ caseDetail.order.productTitle || "—" }}</span></div>
                  <div class="cd-kv"><span class="cd-kvLbl">商品价</span><span class="cd-kvVal">{{ formatMoney(caseDetail.order.price) }}</span></div>
                  <div class="cd-kv"><span class="cd-kvLbl">运费</span><span class="cd-kvVal">{{ formatMoney(caseDetail.order.freight) }}</span></div>
                  <div class="cd-kv"><span class="cd-kvLbl">订单总额</span><span class="cd-kvVal cd-kvVal--emph">{{ formatMoney(caseDetail.order.totalAmount) }}</span></div>
                  <div class="cd-kv"><span class="cd-kvLbl">支付时间</span><span class="cd-kvVal">{{ formatTime(caseDetail.order.payTime) }}</span></div>
                  <div class="cd-kv"><span class="cd-kvLbl">确认收货</span><span class="cd-kvVal">{{ formatTime(caseDetail.order.confirmTime) }}</span></div>
                  <div v-if="caseDetail.order.conditionLevel" class="cd-kv"><span class="cd-kvLbl">成色</span><span class="cd-kvVal">{{ conditionLevelLabel(caseDetail.order.conditionLevel) }}</span></div>
                  <div v-if="caseDetail.order.buyerName || caseDetail.order.buyerPhone" class="cd-kv cd-kv--full"><span class="cd-kvLbl">收货人</span><span class="cd-kvVal">{{ caseDetail.order.buyerName || "—" }} {{ caseDetail.order.buyerPhone || "" }}</span></div>
                  <div v-if="caseDetail.order.buyerAddress" class="cd-kv cd-kv--full"><span class="cd-kvLbl">收货地址</span><span class="cd-kvVal">{{ caseDetail.order.buyerAddress }}</span></div>
                </div>
                <div v-if="caseDetail.inspection" class="cd-inspectionBox">
                  <div class="cd-subTitle">安心购鉴别</div>
                  <div class="cd-kvGrid cd-kvGrid--2">
                    <div class="cd-kv"><span class="cd-kvLbl">流程</span><span class="cd-kvVal">{{ caseDetail.inspection.flowStatusLabel || "—" }}</span></div>
                    <div class="cd-kv"><span class="cd-kvLbl">结论</span><span class="cd-kvVal" :class="{ 'cd-kvVal--bad': caseDetail.inspection.inspectionResult === 2 }">{{ caseDetail.inspection.inspectionResultLabel || "—" }}</span></div>
                    <div v-if="caseDetail.inspection.identifyNo" class="cd-kv"><span class="cd-kvLbl">鉴别号</span><span class="cd-kvVal">{{ caseDetail.inspection.identifyNo }}</span></div>
                    <div v-if="caseDetail.inspection.inspectionIssueDesc" class="cd-kv cd-kv--full"><span class="cd-kvLbl">异常说明</span><span class="cd-kvVal cd-kvVal--pre">{{ caseDetail.inspection.inspectionIssueDesc }}</span></div>
                  </div>
                  <a v-if="caseDetail.inspection.inspectionReportUrl" class="cd-reportLink" :href="caseDetail.inspection.inspectionReportUrl" target="_blank" rel="noopener">查看鉴别报告</a>
                </div>
                <div class="cd-subTitle">发货物流</div>
                <div v-if="shipLogisticsLegs(caseDetail.order).length" class="cd-logiList">
                  <div v-for="(leg, idx) in shipLogisticsLegs(caseDetail.order)" :key="'leg' + idx" class="cd-logiItem">
                    <span v-if="leg.legLabel" class="cd-logiTag">{{ leg.legLabel }}</span>
                    <span class="cd-logiMain">{{ leg.expressCompany || "—" }} · {{ leg.expressNo || "—" }}</span>
                    <span v-if="leg.shipTime" class="cd-logiTime">{{ formatTime(leg.shipTime) }}</span>
                    <el-button
                      v-if="leg.expressNo"
                      type="text"
                      size="mini"
                      class="cd-logiTraceBtn"
                      @click="openLogisticsTrace(leg)"
                    >查看轨迹</el-button>
                  </div>
                </div>
                <div v-else class="cd-empty cd-empty--inline">暂无发货物流</div>
              </template>
            </el-collapse-item>

            <el-collapse-item name="refund">
              <template slot="title">
                <span class="cd-collapseTitle">退款历程</span>
                <span v-if="caseDetail.refundApply" class="cd-collapseBadge">{{ refundApplyStatusLabel(caseDetail.refundApply.applyStatus) }}</span>
              </template>
              <div v-if="!caseDetail.refundApply" class="cd-empty">无关联退款申请</div>
              <template v-else>
                <div class="cd-block">
                  <div class="cd-blockHd"><span class="cd-blockTag cd-blockTag--buyer">买家</span><span class="cd-blockTime">{{ formatTime(caseDetail.refundApply.refundApplyTime) }}</span></div>
                  <div class="cd-kvGrid cd-kvGrid--2">
                    <div class="cd-kv"><span class="cd-kvLbl">类型</span><span class="cd-kvVal">{{ refundTypeLabel(caseDetail.refundApply.refundType) }}</span></div>
                    <div class="cd-kv"><span class="cd-kvLbl">金额</span><span class="cd-kvVal">{{ formatMoney(caseDetail.refundApply.refundAmount) }}</span></div>
                    <div v-if="caseDetail.refundApply.refundType === 1" class="cd-kv"><span class="cd-kvLbl">货物</span><span class="cd-kvVal">{{ refundGoodsStatusLabel(caseDetail.refundApply.refundGoodsStatus) }}</span></div>
                    <div v-if="caseDetail.refundApply.refundType === 2" class="cd-kv"><span class="cd-kvLbl">退货</span><span class="cd-kvVal">{{ returnPhaseLabel(caseDetail.refundApply.returnPhase) }}</span></div>
                    <div class="cd-kv cd-kv--full"><span class="cd-kvLbl">原因</span><span class="cd-kvVal">{{ caseDetail.refundApply.refundReasonLabel || "—" }}</span></div>
                    <div v-if="caseDetail.refundApply.refundApplyDesc" class="cd-kv cd-kv--full"><span class="cd-kvLbl">说明</span><span class="cd-kvVal cd-kvVal--pre">{{ caseDetail.refundApply.refundApplyDesc }}</span></div>
                  </div>
                  <div v-if="caseDetail.refundApply.buyerEvidenceUrls && caseDetail.refundApply.buyerEvidenceUrls.length" class="cd-imgs">
                    <el-image v-for="(u, idx) in caseDetail.refundApply.buyerEvidenceUrls" :key="'be' + idx" class="cd-thumb" :src="u" fit="cover" :preview-src-list="caseDetail.refundApply.buyerEvidenceUrls" />
                  </div>
                </div>
                <div v-if="hasSellerReject(caseDetail.refundApply)" class="cd-block cd-block--divider">
                  <div class="cd-blockHd"><span class="cd-blockTag cd-blockTag--seller">卖家拒绝</span><span class="cd-blockTime">{{ formatTime(caseDetail.refundApply.sellerRejectTime) }}</span></div>
                  <div class="cd-kvGrid">
                    <div class="cd-kv cd-kv--full"><span class="cd-kvLbl">原因</span><span class="cd-kvVal">{{ caseDetail.refundApply.sellerRejectReasonLabel || "—" }}</span></div>
                    <div v-if="caseDetail.refundApply.sellerRejectDesc" class="cd-kv cd-kv--full"><span class="cd-kvLbl">说明</span><span class="cd-kvVal cd-kvVal--pre">{{ caseDetail.refundApply.sellerRejectDesc }}</span></div>
                  </div>
                  <div v-if="caseDetail.refundApply.sellerRejectEvidenceUrls && caseDetail.refundApply.sellerRejectEvidenceUrls.length" class="cd-imgs">
                    <el-image v-for="(u, idx) in caseDetail.refundApply.sellerRejectEvidenceUrls" :key="'se' + idx" class="cd-thumb" :src="u" fit="cover" :preview-src-list="caseDetail.refundApply.sellerRejectEvidenceUrls" />
                  </div>
                </div>
                <div v-if="caseDetail.refundApply.sellerAgreeReturnTime || caseDetail.refundApply.sellerReturnAddressText" class="cd-block cd-block--divider">
                  <div class="cd-blockHd"><span class="cd-blockTag cd-blockTag--seller">卖家同意退货</span><span class="cd-blockTime">{{ formatTime(caseDetail.refundApply.sellerAgreeReturnTime) }}</span></div>
                  <div v-if="caseDetail.refundApply.sellerReturnAddressText" class="cd-kv cd-kv--full">
                    <span class="cd-kvLbl">退货地址</span><span class="cd-kvVal">{{ caseDetail.refundApply.sellerReturnAddressText }}</span>
                  </div>
                </div>
                <div v-if="caseDetail.refundApply.returnLogisticsCompany || caseDetail.refundApply.returnLogisticsNo" class="cd-logiItem cd-logiItem--return">
                  <span class="cd-logiTag">退货物流</span>
                  <span class="cd-logiMain">{{ caseDetail.refundApply.returnLogisticsCompany || "—" }} · {{ caseDetail.refundApply.returnLogisticsNo || "—" }}</span>
                  <span v-if="caseDetail.refundApply.returnSubmitTime" class="cd-logiTime">{{ formatTime(caseDetail.refundApply.returnSubmitTime) }}</span>
                  <el-button
                    v-if="caseDetail.refundApply.returnLogisticsNo"
                    type="text"
                    size="mini"
                    class="cd-logiTraceBtn"
                    @click="openLogisticsTrace({
                      legLabel: '退货物流',
                      expressCompany: caseDetail.refundApply.returnLogisticsCompany,
                      expressNo: caseDetail.refundApply.returnLogisticsNo
                    })"
                  >查看轨迹</el-button>
                </div>
              </template>
            </el-collapse-item>

            <el-collapse-item name="dispute">
              <template slot="title">
                <span class="cd-collapseTitle">纠纷举证</span>
                <span class="cd-collapseBadge">{{ disputeEvidenceTimeline.length }} 条</span>
              </template>
              <div v-if="!disputeEvidenceTimeline.length" class="cd-empty">暂无主张或举证记录</div>
              <div v-else class="cd-timeline">
                <div v-for="(item, idx) in disputeEvidenceTimeline" :key="item.type + (item.id || idx)" class="cd-tlItem">
                  <div class="cd-tlHd">
                    <span class="cd-tlType" :class="item.type === 'claim' ? 'cd-tlType--claim' : 'cd-tlType--sub'">{{ item.type === 'claim' ? '主张' : '举证' }}</span>
                    <span class="cd-tlRole" :class="'cd-tlRole--' + String(item.role || item.party || '').toLowerCase()">{{ disputePartyLabel(item.role || item.party) }}</span>
                    <span class="cd-tlTime">{{ formatTime(item.createTime) }}</span>
                  </div>
                  <div v-if="item.applyClaimValue" class="cd-tlClaim">{{ item.applyClaimValue }}</div>
                  <div v-if="item.reasonText || item.content" class="cd-tlText">{{ item.reasonText || item.content }}</div>
                  <div v-if="item.attachmentUrls && item.attachmentUrls.length" class="cd-imgs">
                    <el-image v-for="(u, ui) in item.attachmentUrls" :key="'att' + idx + ui" class="cd-thumb" :src="u" fit="cover" :preview-src-list="item.attachmentUrls" />
                  </div>
                </div>
              </div>
            </el-collapse-item>

            <el-collapse-item v-if="hasCaseDetailRuling(caseDetail)" name="ruling">
              <template slot="title">
                <span class="cd-collapseTitle">裁定与投票</span>
              </template>
              <div v-if="caseDetail.finalWinner || caseDetail.platformDecision || caseDetail.platformRemark" class="cd-rulingBox">
                <div class="cd-rulingMain">
                  <span class="cd-rulingWinner">{{ finalWinnerLabel(caseDetail.finalWinner) }}</span>
                  <span class="cd-rulingSep">·</span>
                  <span>{{ platformDecisionLabel(caseDetail.platformDecision) }}</span>
                </div>
                <div v-if="caseDetail.platformRemark" class="cd-rulingRemark">{{ caseDetail.platformRemark }}</div>
                <div class="cd-rulingMeta">
                  {{ formatTime(caseDetail.platformDecidedAt || caseDetail.verdictAt) }}
                  <template v-if="caseDetail.resolveChannel"> · {{ caseDetail.resolveChannel }}</template>
                </div>
              </div>
              <div v-if="caseDetail.voteSnapshot && caseDetail.voteSnapshot.hasRound" class="cd-voteBox">
                <div v-if="caseDetail.voteSnapshot.trialLevelLabel || caseDetail.voteSnapshot.voteEndAt" class="cd-voteMeta">
                  <span v-if="caseDetail.voteSnapshot.trialLevelLabel">{{ caseDetail.voteSnapshot.trialLevelLabel }}</span>
                  <span v-if="caseDetail.voteSnapshot.voteEndAt" :class="{ 'cd-urgent': caseDetail.voteSnapshot.voteDeadlineUrgent }">
                    截止 {{ formatTime(caseDetail.voteSnapshot.voteEndAt) }}
                  </span>
                </div>
                <div class="voteSnapStats cd-voteStats">
                  <div class="voteStat voteStat--buyer"><div class="voteStatNum">{{ caseDetail.voteSnapshot.buyerVotes }}</div><div class="voteStatLbl">买</div></div>
                  <div class="voteStat voteStat--seller"><div class="voteStatNum">{{ caseDetail.voteSnapshot.sellerVotes }}</div><div class="voteStatLbl">卖</div></div>
                  <div class="voteStat voteStat--abs"><div class="voteStatNum">{{ caseDetail.voteSnapshot.abstainVotes }}</div><div class="voteStatLbl">弃</div></div>
                </div>
                <div v-if="caseDetail.voteSnapshot.voteVersusHint" class="cd-voteHint">{{ caseDetail.voteSnapshot.voteVersusHint }}</div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <span slot="footer">
        <el-button
          v-if="caseDetail && Number(caseDetail.status) === 5"
          size="small"
          type="warning"
          plain
          :loading="transferToJuryLoading"
          @click="submitTransferToJury(caseDetailCaseId, 'dialog')"
        >流转至小法庭</el-button>
        <el-button size="small" type="primary" plain :loading="caseDetailLoading" @click="fetchCaseDetail">刷新</el-button>
        <el-button size="small" @click="caseDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="voteSnapshotTitle" :visible.sync="voteSnapshotVisible" width="520px" @closed="onVoteSnapshotClosed">
      <div v-loading="voteSnapshotLoading" class="voteSnapWrap">
        <div v-if="!voteSnapshotLoading && !voteSnapshot" class="voteSnapEmpty">暂无数据</div>
        <template v-if="voteSnapshot && !voteSnapshotLoading">
          <div
            v-if="Number(voteSnapshot.caseStatus) === 2 && voteSnapshot.trialLevelLabel"
            class="voteSnapTrialLv"
          >
            当前审级：{{ voteSnapshot.trialLevelLabel }}
          </div>
          <div
            v-if="voteSnapshot.hasRound && voteSnapshot.voteEndAt"
            class="voteSnapMeta"
            :class="{ 'voteSnapMeta--urgent': voteSnapshot.voteDeadlineUrgent }"
          >
            <span>投票截止 {{ formatTime(voteSnapshot.voteEndAt) }}</span>
          </div>
          <div v-if="voteSnapshot.hasRound" class="voteSnapStats">
            <div class="voteStat voteStat--buyer">
              <div class="voteStatNum">{{ voteSnapshot.buyerVotes }}</div>
              <div class="voteStatLbl">支持买家</div>
            </div>
            <div class="voteStat voteStat--seller">
              <div class="voteStatNum">{{ voteSnapshot.sellerVotes }}</div>
              <div class="voteStatLbl">支持卖家</div>
            </div>
            <div class="voteStat voteStat--abs">
              <div class="voteStatNum">{{ voteSnapshot.abstainVotes }}</div>
              <div class="voteStatLbl">弃权</div>
            </div>
          </div>
          <div v-if="voteSnapshot.hasRound" class="voteStatTotal">合计 {{ voteSnapshot.totalVotes }} 票</div>
          <el-alert
            v-if="voteSnapshot.voteVersusHint"
            :title="voteSnapshot.voteVersusHint"
            type="info"
            :closable="false"
            show-icon
            class="voteSnapAlert"
          />
        </template>
      </div>
      <span slot="footer">
        <el-button size="small" type="primary" plain @click="fetchVoteSnapshot" :loading="voteSnapshotLoading">刷新</el-button>
        <el-button size="small" @click="voteSnapshotVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="logisticsTraceTitle"
      :visible.sync="logisticsTraceVisible"
      width="560px"
      append-to-body
      @closed="onLogisticsTraceClosed"
    >
      <div v-loading="logisticsTraceLoading" class="cd-traceWrap">
        <div v-if="logisticsTraceQuery.expressNo" class="cd-traceHd">
          <div class="cd-traceRow">
            <span class="cd-traceLbl">物流</span>
            <span class="cd-traceVal">{{ logisticsTraceCompanyLabel }} · {{ logisticsTraceQuery.expressNo }}</span>
          </div>
          <div v-if="logisticsTraceQuery.legLabel" class="cd-traceRow">
            <span class="cd-traceLbl">环节</span>
            <span class="cd-traceVal">{{ logisticsTraceQuery.legLabel }}</span>
          </div>
        </div>
        <div v-if="!logisticsTraceLoading && !logisticsTraceList.length" class="cd-empty">暂无轨迹信息</div>
        <el-timeline v-else-if="logisticsTraceList.length" class="cd-traceTimeline">
          <el-timeline-item
            v-for="(item, idx) in logisticsTraceList"
            :key="'lt' + idx + (item.time || '')"
            :timestamp="item.time || ''"
            placement="top"
          >
            {{ item.context }}
          </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer">
        <el-button size="small" type="primary" plain :loading="logisticsTraceLoading" @click="fetchLogisticsTrace">刷新</el-button>
        <el-button size="small" @click="logisticsTraceVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="platformDialogTitle" :visible.sync="platformDialogVisible" width="520px">
      <el-form label-width="120px" size="small">
        <el-alert
          v-if="platformMode === 'appealReview'"
          type="warning"
          :closable="false"
          show-icon
          class="appealReviewAlert"
          title="针对败诉方已提交的「判定申诉」作出终局复核；提交后立即按所选胜方结案（汇付退款或驳回），不再开放申诉。"
        />
        <el-form-item label="胜出方" required>
          <el-radio-group v-model="platformForm.finalWinner">
            <el-radio label="BUYER">买家胜出</el-radio>
            <el-radio label="SELLER">卖家胜出</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="platformMode !== 'appealReview'" label="败诉方可申诉">
          <el-switch
            v-model="platformForm.allowAppeal"
            active-text="允许 48 小时申诉"
            inactive-text="不予申诉，当场结案"
          />
          <div class="formHint">关闭申诉时买家胜将立即触发原路退款；开启则期满后自动结案</div>
        </el-form-item>
        <el-form-item label="说明/备注">
          <el-input v-model="platformForm.platformRemark" type="textarea" :rows="3" maxlength="500" show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="platformDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="platformSubmitting" @click="submitPlatformVerdict">确定</el-button>
      </span>
    </el-dialog>

    <div class="page_box">
      <el-pagination
        @current-change="changePage"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="tableTotal"
      />
    </div>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";
import expressInfo from "@/util/expressInfo";

export default {
  data() {
    return {
      historyArr: ["纠纷订单列表"],
      loading: false,

      statusOptions: [
        { label: "全部", value: null },
        { label: "无判定结案", value: -1 },
        { label: "主张/举证", value: 1 },
        { label: "评审投票", value: 2 },
        { label: "已裁定（待结案）", value: 3 },
        { label: "已结案", value: 4 },
      ],

      query: {
        orderNo: "",
        buyerNickName: "",
        sellerNickName: "",
        status: null,
        platformUserAppealedOnly: false,
      },

      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableTotal: 0,

      sockPuppets: [],
      sockPuppetsVoted: [],
      sockPuppetPickHint: "",
      sockPuppetVotable: true,
      sockPuppetRoundMeta: "",
      sockPuppetRoundTotal: null,
      sockPuppetRoundCap: null,
      sockPuppetRoundRemaining: null,
      sockPuppetsLoading: false,
      sockPuppetFilter: "",
      sockDialogVisible: false,
      sockSubmitting: false,
      sockForm: {
        caseId: null,
        sockPuppetIds: [],
        choice: "BUYER",
        reasonTag: "",
        reasonDetail: "",
      },
      buyerVoteReasonLabels: [
        "商品有破损",
        "品质粗劣",
        "性能低下",
        "存在功能故障",
        "缺少配件",
        "其他质量问题",
      ],
      sellerVoteReasonLabels: [
        "无功能故障",
        "性能良好",
        "商品无破损",
        "无质量问题",
        "买家举证不足",
        "与描述一致",
        "卖家已履约",
        "其他",
      ],

      platformDialogVisible: false,
      platformSubmitting: false,
      platformMode: "simple",
      platformForm: {
        caseId: null,
        finalWinner: "BUYER",
        allowAppeal: true,
        platformRemark: "",
      },

      voteSnapshotVisible: false,
      voteSnapshotLoading: false,
      voteSnapshot: null,
      voteSnapshotCaseId: null,
      voteSnapshotOrderNo: "",

      caseDetailVisible: false,
      caseDetailLoading: false,
      caseDetail: null,
      caseDetailCaseId: null,
      caseDetailOrderNo: "",
      caseDetailCollapseActive: ["timeline", "trade", "refund", "dispute"],
      transferToJuryLoading: false,
      transferToJuryRowId: null,

      logisticsTraceVisible: false,
      logisticsTraceLoading: false,
      logisticsTraceList: [],
      logisticsTraceQuery: {
        legLabel: "",
        expressCompany: "",
        expressNo: "",
        com: "",
      },
    };
  },

  computed: {
    sockReasonOptions() {
      if (this.sockForm.choice === "BUYER") return this.buyerVoteReasonLabels;
      if (this.sockForm.choice === "SELLER") return this.sellerVoteReasonLabels;
      return [];
    },
    filteredSockPuppets() {
      const q = String(this.sockPuppetFilter || "")
        .trim()
        .toLowerCase();
      if (!q) return this.sockPuppets;
      return (this.sockPuppets || []).filter((p) => {
        if (!p) return false;
        const nick = String(p.nickName || "").toLowerCase();
        const idStr = p.id != null ? String(p.id) : "";
        return nick.includes(q) || idStr.includes(q);
      });
    },
    /** 与接口 remainingVoteSlots 一致，用于限制多选个数 */
    sockPuppetPickLimit() {
      const r = Number(this.sockPuppetRoundRemaining);
      return Number.isFinite(r) && r >= 0 ? r : null;
    },
    platformDialogTitle() {
      if (this.platformMode === "simple") return "平台简易裁";
      if (this.platformMode === "appealReview") return "判定申诉·平台复核改判";
      return "平台强制裁定（评审期）";
    },
    voteSnapshotTitle() {
      const on = (this.voteSnapshotOrderNo || "").trim();
      let t = on ? `投票与结果（${on}）` : "投票与结果";
      const snap = this.voteSnapshot;
      if (snap && Number(snap.caseStatus) === 2 && snap.trialLevelLabel) {
        t += " · " + snap.trialLevelLabel;
      }
      return t;
    },
    caseDetailTitle() {
      const on = (this.caseDetailOrderNo || "").trim();
      return on ? `案件详情（${on}）` : "案件详情";
    },
    logisticsTraceTitle() {
      const label = (this.logisticsTraceQuery.legLabel || "").trim();
      return label ? `物流轨迹 · ${label}` : "物流轨迹";
    },
    logisticsTraceCompanyLabel() {
      const q = this.logisticsTraceQuery || {};
      const com = (q.com || "").trim();
      const company = (q.expressCompany || "").trim();
      if (com && expressInfo.obj && expressInfo.obj[com] && expressInfo.obj[com].title) {
        return expressInfo.obj[com].title;
      }
      return company || com || "—";
    },
    /** 主张 + 举证按时间合并为时间线 */
    disputeEvidenceTimeline() {
      const d = this.caseDetail;
      if (!d) return [];
      const items = [];
      (d.claims || []).forEach((cl) => {
        if (cl) items.push({ type: "claim", ...cl });
      });
      (d.submissions || []).forEach((sb) => {
        if (sb) items.push({ type: "submission", ...sb, role: sb.party });
      });
      items.sort((a, b) => {
        const ta = a && a.createTime ? new Date(a.createTime).getTime() : 0;
        const tb = b && b.createTime ? new Date(b.createTime).getTime() : 0;
        return ta - tb;
      });
      return items;
    },
  },

  mounted() {
    this.fetchList(1);
  },

  methods: {
    statusLabel(v) {
      if (v === -1) return "无判定结案";
      if (v === 1) return "主张/举证";
      if (v === 5) return "平台客服处理";
      if (v === 2) return "评审投票";
      if (v === 3) return "已裁定（待结案）";
      if (v === 4) return "已结案";
      return String(v == null ? "-" : v);
    },

    /** 评审阶段拼接一审/二审/三审 */
    disputeStatusCell(row) {
      const base = this.statusLabel(row && row.status);
      if (!row || row.status !== 2) return base;
      const trial =
        row.voteTrialLevelLabel ||
        (row.voteSnapshot && row.voteSnapshot.trialLevelLabel) ||
        "";
      if (trial) return base + "（" + trial + "）";
      return base;
    },

    statusColor(v) {
      if (v === -1) return "#909399";
      if (v === 1) return "#e6a23c";
      if (v === 5) return "#f56c6c";
      if (v === 2) return "#409eff";
      if (v === 3) return "#67c23a";
      if (v === 4) return "#529b2e";
      return "#333";
    },

    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },

    disputePartyLabel(role) {
      const r = String(role || "").toUpperCase();
      if (r === "BUYER") return "买家";
      if (r === "SELLER") return "卖家";
      return role || "—";
    },

    formatMoney(v) {
      if (v === null || v === undefined || v === "") return "—";
      const n = Number(v);
      if (!Number.isFinite(n)) return String(v);
      return "¥" + n.toFixed(2);
    },

    secondhandOrderStatusLabel(v) {
      const x = Number(v);
      const m = {
        0: "待支付",
        1: "待发货",
        2: "待收货",
        3: "待评价",
        4: "已完成",
        5: "已退款",
        6: "已取消",
        7: "退款中",
        8: "安心购中",
      };
      return m[x] != null ? m[x] : String(v == null ? "—" : v);
    },

    refundTypeLabel(v) {
      const x = Number(v);
      if (x === 1) return "仅退款";
      if (x === 2) return "退货退款";
      return v == null || v === "" ? "—" : String(v);
    },

    refundApplyStatusLabel(v) {
      const x = Number(v);
      const m = { 0: "已关闭", 1: "待卖家处理", 2: "卖家已同意", 3: "卖家已拒绝", 4: "退款成功" };
      return m[x] != null ? m[x] : String(v == null ? "—" : v);
    },

    refundGoodsStatusLabel(v) {
      const x = Number(v);
      if (x === 1) return "未收到货";
      if (x === 2) return "已收到货";
      if (x === 3) return "已拒收";
      return v == null || v === "" ? "—" : String(v);
    },

    returnPhaseLabel(v) {
      const x = Number(v);
      const m = { 0: "无/仅退款", 1: "待买家寄回", 2: "待卖家确认收货", 3: "卖家已确认收货" };
      return m[x] != null ? m[x] : String(v == null ? "—" : v);
    },

    finalWinnerLabel(v) {
      const r = String(v || "").toUpperCase();
      if (r === "BUYER") return "买家胜";
      if (r === "SELLER") return "卖家胜";
      if (r === "NONE") return "无/未决";
      return v || "—";
    },

    platformDecisionLabel(v) {
      const r = String(v || "").toUpperCase();
      if (r === "REFUND_OK" || r === "SELLER_AGREE") return "同意退款（REFUND_OK）";
      if (r === "REFUND_DENY") return "驳回退款（REFUND_DENY）";
      return v || "—";
    },

    /** 发货物流：优先接口 shipLogistics，兼容旧字段 logisticsCompany/No */
    progressOperatorLabel(role) {
      const r = Number(role);
      if (r === 1) return "买家";
      if (r === 2) return "卖家";
      if (r === 3) return "平台";
      return "—";
    },

    conditionLevelLabel(v) {
      const m = { 1: "全新", 2: "几乎全新", 3: "轻微使用", 4: "明显使用", 5: "需要维修" };
      const x = Number(v);
      return m[x] != null ? m[x] : String(v == null ? "—" : v);
    },

    shipLogisticsLegs(order) {
      if (!order) return [];
      const list = order.shipLogistics;
      if (Array.isArray(list) && list.length) return list;
      if (order.logisticsCompany || order.logisticsNo || order.shipTime) {
        return [
          {
            legLabel: order.useInspection === 1 ? "卖家直发（兼容字段）" : "卖家发货",
            expressCompany: order.logisticsCompany,
            expressNo: order.logisticsNo,
            shipTime: order.shipTime,
          },
        ];
      }
      return [];
    },

    onCaseDetailClosed() {
      this.caseDetail = null;
      this.caseDetailCaseId = null;
      this.caseDetailOrderNo = "";
      this.caseDetailCollapseActive = ["timeline", "trade", "refund", "dispute"];
      this.logisticsTraceVisible = false;
    },

    onLogisticsTraceClosed() {
      this.logisticsTraceList = [];
      this.logisticsTraceQuery = {
        legLabel: "",
        expressCompany: "",
        expressNo: "",
        com: "",
      };
    },

    mapExpressCompanyToCode(company) {
      const raw = String(company || "").trim();
      if (!raw) return "";
      const lower = raw.toLowerCase();
      if (expressInfo.obj && expressInfo.obj[lower]) return lower;
      if (expressInfo.obj && expressInfo.obj[raw]) return raw;
      const arr = expressInfo.arr || [];
      for (let i = 0; i < arr.length; i++) {
        const it = arr[i];
        if (!it) continue;
        if (it.title === raw || it.code === lower) return it.code;
        if (raw.includes(it.title) || it.title.includes(raw)) return it.code;
      }
      return lower.replace(/\s/g, "");
    },

    resolveLogisticsComCode(company, num) {
      const mapped = this.mapExpressCompanyToCode(company);
      if (mapped) return Promise.resolve(mapped);
      const no = String(num || "").trim();
      if (!no || !this.$api.api.kuaidiCloudAutoNumber) return Promise.resolve("");
      const url = `${this.$api.api.kuaidiCloudAutoNumber}?num=${encodeURIComponent(no)}`;
      return this.$https(url, {}, "GET")
        .then((res) => {
          if (!res.data || res.data.code !== 200) return "";
          let payload = res.data.data;
          if (payload == null || payload === "") return "";
          if (typeof payload === "string") {
            try {
              payload = JSON.parse(payload);
            } catch (e) {
              return "";
            }
          }
          if (payload && payload.returnCode != null) return "";
          const arr = Array.isArray(payload) ? payload : null;
          if (!arr || !arr.length) return "";
          const first = arr[0] || {};
          return String(first.comCode || "").trim();
        })
        .catch(() => "");
    },

    logisticsTracePhone() {
      const o = this.caseDetail && this.caseDetail.order;
      const phone = o && o.buyerPhone ? String(o.buyerPhone).trim() : "";
      return phone || "";
    },

    parseLogisticsTraceResponse(dataStr) {
      try {
        const root = typeof dataStr === "string" ? JSON.parse(dataStr) : dataStr;
        const list = root && root.data;
        if (Array.isArray(list) && list.length) {
          return list
            .map((item) => ({
              time: (item && (item.ftime || item.time)) || "",
              context: (item && (item.context || item.status)) || "",
            }))
            .reverse();
        }
        const msg = (root && (root.message || root.msg)) || "暂无轨迹信息";
        return [{ time: "", context: msg }];
      } catch (e) {
        return [{ time: "", context: "轨迹数据解析失败" }];
      }
    },

    openLogisticsTrace(leg) {
      if (!leg || !leg.expressNo) {
        this.$message.warning("缺少快递单号");
        return;
      }
      this.logisticsTraceQuery = {
        legLabel: leg.legLabel || "",
        expressCompany: leg.expressCompany || "",
        expressNo: String(leg.expressNo).trim(),
        com: "",
      };
      this.logisticsTraceList = [];
      this.logisticsTraceVisible = true;
      this.fetchLogisticsTrace();
    },

    fetchLogisticsTrace() {
      const q = this.logisticsTraceQuery || {};
      const num = String(q.expressNo || "").trim();
      if (!num) return;
      if (!this.logisticsTraceVisible) return;
      this.logisticsTraceLoading = true;
      this.resolveLogisticsComCode(q.expressCompany, num)
        .then((com) => {
          if (!com) {
            this.logisticsTraceList = [{ time: "", context: "无法识别快递公司，请核对公司名称" }];
            return null;
          }
          this.logisticsTraceQuery = { ...this.logisticsTraceQuery, com };
          const params = new URLSearchParams({ com, num });
          const phone = this.logisticsTracePhone();
          if (phone) params.set("phone", phone);
          const url = `${this.$api.api.kuaidiSelect}?${params.toString()}`;
          return this.$https(url, {}, "GET");
        })
        .then((res) => {
          if (res == null) return;
          if (res.data && res.data.code === 200) {
            this.logisticsTraceList = this.parseLogisticsTraceResponse(res.data.data);
          } else {
            this.logisticsTraceList = [
              { time: "", context: (res.data && res.data.msg) || "查询失败" },
            ];
          }
        })
        .catch(() => {
          this.logisticsTraceList = [{ time: "", context: "查询失败，请稍后重试" }];
        })
        .finally(() => {
          this.logisticsTraceLoading = false;
        });
    },

    syncCaseDetailCollapse() {
      const names = ["timeline", "trade", "refund", "dispute"];
      if (this.hasCaseDetailRuling(this.caseDetail)) names.push("ruling");
      this.caseDetailCollapseActive = names;
    },

    hasCaseDetailRuling(d) {
      if (!d) return false;
      if (d.finalWinner || d.platformDecision || d.platformRemark || d.verdictAt) return true;
      return !!(d.voteSnapshot && d.voteSnapshot.hasRound);
    },

    hasSellerReject(ra) {
      if (!ra) return false;
      return !!(
        ra.sellerRejectReasonLabel ||
        ra.sellerRejectDesc ||
        (ra.sellerRejectEvidenceUrls && ra.sellerRejectEvidenceUrls.length)
      );
    },

    caseDetailStatusTagType(status) {
      const s = Number(status);
      if (s === -1) return "info";
      if (s === 1) return "warning";
      if (s === 5) return "danger";
      if (s === 2) return "";
      if (s === 3 || s === 4) return "success";
      return "info";
    },

    openCaseDetail(row) {
      if (!row || row.caseId == null) {
        this.$message.warning("缺少纠纷信息");
        return;
      }
      this.caseDetailCaseId = row.caseId;
      this.caseDetailOrderNo = row.orderNo || "";
      this.caseDetail = null;
      this.caseDetailVisible = true;
      this.caseDetailLoading = true;
      this.fetchCaseDetail();
    },

    fetchCaseDetail() {
      if (this.caseDetailCaseId == null) return;
      if (!this.caseDetailVisible) return;
      this.caseDetailLoading = true;
      const url = `${this.$api.api.secondhandDisputeCaseDetail}?caseId=${encodeURIComponent(this.caseDetailCaseId)}`;
      this.$https(url, {}, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.caseDetail = res.data.data || null;
            this.syncCaseDetailCollapse();
          } else {
            this.caseDetail = null;
            this.$message.error((res.data && res.data.msg) || "加载失败");
          }
        })
        .catch(() => {
          this.caseDetail = null;
        })
        .finally(() => {
          this.caseDetailLoading = false;
        });
    },

    resetFn() {
      this.query = {
        orderNo: "",
        buyerNickName: "",
        sellerNickName: "",
        status: null,
        platformUserAppealedOnly: false,
      };
      this.currentPage = 1;
      this.fetchList(1);
    },

    searchFn() {
      this.currentPage = 1;
      this.fetchList(1);
    },

    changePage(p) {
      this.fetchList(p);
    },

    fetchList(page) {
      this.loading = true;
      const obj = { page: page || 1, size: this.pageSize };
      const on = String(this.query.orderNo || "").trim();
      if (on) obj.orderNo = on;
      const bn = String(this.query.buyerNickName || "").trim();
      const sn = String(this.query.sellerNickName || "").trim();
      if (bn) obj.buyerNickName = bn;
      if (sn) obj.sellerNickName = sn;
      if (this.query.status != null) obj.status = this.query.status;
      if (this.query.platformUserAppealedOnly === true) obj.platformUserAppealedOnly = true;

      this.$https(this.$api.api.selSecondhandDisputeCase, obj, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onVoteSnapshotClosed() {
      this.voteSnapshot = null;
      this.voteSnapshotCaseId = null;
      this.voteSnapshotOrderNo = "";
    },

    openVoteSnapshot(row) {
      if (!row || row.caseId == null) {
        this.$message.warning("缺少纠纷信息");
        return;
      }
      this.voteSnapshotCaseId = row.caseId;
      this.voteSnapshotOrderNo = row.orderNo || "";
      this.voteSnapshot = null;
      this.voteSnapshotVisible = true;
      this.voteSnapshotLoading = true;
      this.fetchVoteSnapshot();
    },

    fetchVoteSnapshot() {
      if (this.voteSnapshotCaseId == null) return;
      if (!this.voteSnapshotVisible) return;
      this.voteSnapshotLoading = true;
      const url = `${this.$api.api.secondhandDisputeVoteSnapshot}?caseId=${encodeURIComponent(this.voteSnapshotCaseId)}`;
      this.$https(url, {}, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.voteSnapshot = res.data.data || null;
          } else {
            this.voteSnapshot = null;
            this.$message.error((res.data && res.data.msg) || "加载失败");
          }
        })
        .catch(() => {
          this.voteSnapshot = null;
        })
        .finally(() => {
          this.voteSnapshotLoading = false;
        });
    },

    loadSockPuppets() {
      if (!this.sockForm.caseId) {
        this.sockPuppets = [];
        this.sockPuppetsVoted = [];
        this.sockPuppetPickHint = "";
        this.sockPuppetVotable = false;
        this.sockPuppetRoundMeta = "";
        this.sockPuppetRoundTotal = null;
        this.sockPuppetRoundCap = null;
        this.sockPuppetRoundRemaining = null;
        return;
      }
      this.sockPuppetsLoading = true;
      const url = `${this.$api.api.secondhandDisputeSockPuppetsForCase}?caseId=${encodeURIComponent(this.sockForm.caseId)}`;
      this.$https(url, {}, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            const pick = res.data.data || {};
            this.sockPuppets = pick.available || [];
            this.sockPuppetsVoted = pick.alreadyVoted || [];
            this.sockPuppetPickHint = pick.hint || "";
            this.sockPuppetVotable = pick.votable === true;
            this.sockPuppetRoundTotal = pick.currentRoundTotalVotes != null ? pick.currentRoundTotalVotes : null;
            this.sockPuppetRoundCap = pick.roundVoteCap != null ? pick.roundVoteCap : null;
            this.sockPuppetRoundRemaining = pick.remainingVoteSlots != null ? pick.remainingVoteSlots : null;
            if (pick.roundId != null) {
              const rn = pick.roundNo != null ? pick.roundNo : "—";
              const st = pick.roundStatus || "—";
              const t = this.sockPuppetRoundTotal != null ? this.sockPuppetRoundTotal : "—";
              const cap = this.sockPuppetRoundCap != null ? this.sockPuppetRoundCap : 21;
              const rem = this.sockPuppetRoundRemaining != null ? this.sockPuppetRoundRemaining : "—";
              this.sockPuppetRoundMeta = `当前投票轮：第 ${rn} 审 · 状态 ${st} · 本轮已累计 ${t}/${cap} 票 · 还可投 ${rem} 票`;
            } else {
              this.sockPuppetRoundMeta = "";
              this.sockPuppetRoundTotal = null;
              this.sockPuppetRoundCap = null;
              this.sockPuppetRoundRemaining = null;
            }
            const allowed = new Set((this.sockPuppets || []).map((p) => p && p.id).filter((id) => id != null));
            let ids = (this.sockForm.sockPuppetIds || []).filter((id) => allowed.has(id));
            const lim = this.sockPuppetPickLimit;
            if (lim != null && ids.length > lim) {
              ids = ids.slice(0, lim);
              this.$message.warning(`本轮最多还可投 ${lim} 票，已自动保留前 ${lim} 个已选马甲`);
            }
            this.sockForm.sockPuppetIds = ids;
          } else {
            this.sockPuppets = [];
            this.sockPuppetsVoted = [];
            this.sockPuppetPickHint = (res.data && res.data.msg) || "加载失败";
            this.sockPuppetVotable = false;
            this.sockPuppetRoundMeta = "";
            this.sockPuppetRoundTotal = null;
            this.sockPuppetRoundCap = null;
            this.sockPuppetRoundRemaining = null;
            this.$message.error(this.sockPuppetPickHint);
          }
        })
        .catch(() => {
          this.sockPuppets = [];
          this.sockPuppetsVoted = [];
          this.sockPuppetPickHint = "网络错误";
          this.sockPuppetVotable = false;
          this.sockPuppetRoundMeta = "";
          this.sockPuppetRoundTotal = null;
          this.sockPuppetRoundCap = null;
          this.sockPuppetRoundRemaining = null;
        })
        .finally(() => {
          this.sockPuppetsLoading = false;
        });
    },

    openSockVote(row) {
      this.sockPuppetFilter = "";
      this.sockPuppets = [];
      this.sockPuppetsVoted = [];
      this.sockPuppetPickHint = "";
      this.sockPuppetVotable = true;
      this.sockPuppetRoundMeta = "";
      this.sockPuppetRoundTotal = null;
      this.sockPuppetRoundCap = null;
      this.sockPuppetRoundRemaining = null;
      this.sockForm = {
        caseId: row.caseId,
        sockPuppetIds: [],
        choice: "BUYER",
        reasonTag: "",
        reasonDetail: "",
      };
      this.sockDialogVisible = true;
      this.loadSockPuppets();
    },

    toggleSockPuppet(p) {
      if (!p || p.id == null) return;
      const id = p.id;
      const ids = [...(this.sockForm.sockPuppetIds || [])];
      const i = ids.indexOf(id);
      if (i !== -1) {
        ids.splice(i, 1);
        this.sockForm.sockPuppetIds = ids;
        return;
      }
      const lim = this.sockPuppetPickLimit;
      if (lim != null && ids.length >= lim) {
        this.$message.warning(`本轮剩余可投 ${lim} 票，无法再增加已选马甲，请先取消部分选择或分次提交`);
        return;
      }
      this.sockForm.sockPuppetIds = [...ids, id];
    },

    clearSockSelection() {
      this.sockForm.sockPuppetIds = [];
    },

    submitSockVote() {
      if (!this.sockForm.caseId) {
        this.$message.warning("缺少纠纷信息");
        return;
      }
      if (!this.sockPuppetVotable) {
        this.$message.warning("当前轮次不可投票");
        return;
      }
      if (!this.sockForm.sockPuppetIds || !this.sockForm.sockPuppetIds.length) {
        this.$message.warning("请至少选择一个马甲用户");
        return;
      }
      const lim = this.sockPuppetPickLimit;
      if (lim != null && this.sockForm.sockPuppetIds.length > lim) {
        this.$message.warning(`本轮最多还可投 ${lim} 票，请减少已选马甲后再提交`);
        return;
      }
      if (this.sockForm.choice === "BUYER" || this.sockForm.choice === "SELLER") {
        if (!String(this.sockForm.reasonTag || "").trim()) {
          this.$message.warning("请选择投票理由");
          return;
        }
      }
      const payload = {
        caseId: this.sockForm.caseId,
        sockPuppetIds: [...this.sockForm.sockPuppetIds],
        choice: this.sockForm.choice,
        reasonTag: String(this.sockForm.reasonTag || "").trim() || undefined,
        reasonDetail: String(this.sockForm.reasonDetail || "").trim() || undefined,
      };
      if (this.sockForm.choice === "ABSTAIN") {
        payload.reasonTag = undefined;
      }
      this.sockSubmitting = true;
      this.$https(this.$api.api.secondhandDisputeSockVoteBatch, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success(res.data.msg || "投票成功");
            this.sockForm.sockPuppetIds = [];
            this.sockForm.reasonTag = "";
            this.sockForm.reasonDetail = "";
            this.loadSockPuppets();
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "投票失败");
          }
        })
        .finally(() => {
          this.sockSubmitting = false;
        });
    },

    openPlatformVerdict(row, mode) {
      this.platformMode = mode;
      const appealReview = mode === "appealReview";
      this.platformForm = {
        caseId: row.caseId,
        finalWinner: "BUYER",
        allowAppeal: !appealReview,
        platformRemark: "",
      };
      this.platformDialogVisible = true;
    },

    submitPlatformVerdict() {
      if (!this.platformForm.caseId) {
        this.$message.warning("缺少纠纷信息");
        return;
      }
      if (!this.platformForm.finalWinner) {
        this.$message.warning("请选择胜出方");
        return;
      }
      const payload = {
        caseId: this.platformForm.caseId,
        finalWinner: this.platformForm.finalWinner,
        allowAppeal: this.platformMode === "appealReview" ? false : !!this.platformForm.allowAppeal,
        platformRemark: String(this.platformForm.platformRemark || "").trim() || undefined,
      };
      let url = this.$api.api.secondhandDisputePlatformVerdictAppealReview;
      if (this.platformMode === "simple") {
        url = this.$api.api.secondhandDisputePlatformSimple;
      } else if (this.platformMode === "forceJury") {
        url = this.$api.api.secondhandDisputePlatformForceJury;
      }
      this.platformSubmitting = true;
      this.$https(url, payload, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("操作成功");
            this.platformDialogVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .finally(() => {
          this.platformSubmitting = false;
        });
    },

    submitTransferToJury(caseId, source) {
      if (caseId == null) {
        this.$message.warning("缺少纠纷信息");
        return;
      }
      const url = `${this.$api.api.secondhandDisputeTransferToJury}?caseId=${encodeURIComponent(caseId)}`;
      if (source === "dialog") this.transferToJuryLoading = true;
      else this.transferToJuryRowId = caseId;
      this.$https(url, {}, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success("已流转至小法庭");
            this.fetchList(this.currentPage);
            if (this.caseDetailVisible && Number(this.caseDetailCaseId) === Number(caseId)) {
              this.fetchCaseDetail();
            }
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .finally(() => {
          if (source === "dialog") this.transferToJuryLoading = false;
          else this.transferToJuryRowId = null;
        });
    },
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;
  .topBox {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }
  .topLeft {
    align-items: center;
  }
  .page_box {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
  }
  .productThumb {
    width: 56px;
    height: 56px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    vertical-align: middle;
  }
  .productThumbPlaceholder {
    color: #c0c4cc;
    font-size: 14px;
  }
  .userCell {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    max-width: 140px;
  }
  .userAvatar {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid #ebeef5;
    flex-shrink: 0;
  }
  .userName {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ::v-deep .col-actions .cell {
    padding-left: 6px;
    padding-right: 6px;
  }
  .actionStack {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    padding: 4px 0;
  }
  .actionBtnFull {
    margin: 0 !important;
    width: 100%;
    padding-left: 6px;
    padding-right: 6px;
  }
  .actionBtnSnap {
    font-weight: 600;
  }
  .actionPlaceholder {
    color: #c0c4cc;
    font-size: 12px;
    padding: 6px 0;
  }
  .voteSnapWrap {
    min-height: 120px;
  }
  .voteSnapTrialLv {
    font-size: 13px;
    font-weight: 600;
    color: #409eff;
    margin-bottom: 8px;
  }
  .voteSnapMeta {
    font-size: 13px;
    color: #606266;
    line-height: 1.5;
    margin-bottom: 12px;
  }
  .voteSnapMeta--urgent {
    color: #f56c6c;
    font-weight: 600;
  }
  .voteSnapStats {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
  }
  .voteStat {
    flex: 1;
    text-align: center;
    padding: 10px 4px 8px;
    border-radius: 6px;
    background: #f5f7fa;
    border: 1px solid #ebeef5;
  }
  .voteStat--buyer {
    border-top: 3px solid #67c23a;
  }
  .voteStat--seller {
    border-top: 3px solid #e6a23c;
  }
  .voteStat--abs {
    border-top: 3px solid #909399;
  }
  .voteStatNum {
    font-size: 22px;
    font-weight: 700;
    color: #303133;
    line-height: 1.2;
  }
  .voteStatLbl {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
  }
  .voteStatTotal {
    font-size: 12px;
    color: #909399;
    text-align: right;
    margin-bottom: 10px;
  }
  .voteSnapAlert {
    margin-top: 4px;
  }
  .voteSnapAlert ::v-deep .el-alert__title {
    font-size: 13px;
    line-height: 1.5;
  }
  .voteSnapEmpty {
    padding: 24px;
    text-align: center;
    color: #909399;
    font-size: 13px;
  }
  .sockPuppetToolbar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 4px;
  }
  .sockPuppetHint {
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
    flex: 1;
    min-width: 0;
  }
  .sockPuppetCount {
    font-size: 12px;
    color: #606266;
    margin-bottom: 4px;
  }
  .sockPuppetList {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fafafa;
  }
  .sockPuppetRow {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 5px 8px;
    cursor: pointer;
    border-bottom: 1px solid #ebeef5;
    transition: background 0.15s;
    &:last-child {
      border-bottom: none;
    }
    &:hover {
      background: #f0f9ff;
    }
    &.active {
      background: #ecf5ff;
      box-shadow: inset 2px 0 0 #409eff;
    }
  }
  .sockPuppetAvatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
    border: 1px solid #ebeef5;
    background: #fff;
  }
  .sockPuppetAvatar--ph {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    color: #909399;
    background: #ebeef5;
  }
  .sockPuppetMeta {
    min-width: 0;
    flex: 1;
  }
  .sockPuppetName {
    font-size: 13px;
    color: #303133;
    font-weight: 500;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .sockPuppetEmpty {
    padding: 12px;
    text-align: center;
    color: #909399;
    font-size: 12px;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
  }
  .sockDialogInner {
    min-height: 80px;
  }
  .sockPickAlert {
    margin-bottom: 10px;
  }
  .sockPickAlert ::v-deep .el-alert__title {
    font-size: 13px;
    line-height: 1.45;
  }
  .sockRoundMeta {
    font-size: 12px;
    color: #909399;
    margin-bottom: 12px;
  }
  .sockVotedBlock {
    margin-bottom: 14px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ebeef5;
  }
  .sockVotedTitle {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 8px;
  }
  .sockVotedList {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    background: #fafafa;
  }
  .sockVotedRow {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 8px 10px;
    border-bottom: 1px solid #ebeef5;
    &:last-child {
      border-bottom: none;
    }
  }
  .sockVotedAvatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
    border: 1px solid #ebeef5;
    background: #fff;
  }
  .sockVotedAvatar--ph {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 600;
    color: #909399;
    background: #ebeef5;
  }
  .sockVotedMeta {
    min-width: 0;
    flex: 1;
  }
  .sockVotedName {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    line-height: 1.3;
  }
  .sockVotedSub {
    font-size: 12px;
    color: #606266;
    margin-top: 2px;
    line-height: 1.4;
  }
  .sockVotedDetail {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.45;
  }
  .sockVotedTime {
    font-size: 11px;
    color: #c0c4cc;
    margin-top: 4px;
  }
  .sockVoteForm {
    margin-top: 4px;
  }
  .voteTallyCell {
    line-height: 1.35;
    padding: 2px 0;
  }
  .voteTallyNums {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
  }
  .voteTallyB {
    color: #67c23a;
  }
  .voteTallyS {
    color: #e6a23c;
  }
  .voteTallyA {
    color: #909399;
  }
  .voteTallySep {
    color: #dcdfe6;
    margin: 0 2px;
    font-weight: 400;
  }
  .voteTallySub {
    font-size: 11px;
    color: #909399;
    margin-top: 2px;
  }
  .voteTallySub--urgent {
    color: #f56c6c;
    font-weight: 600;
  }
  .voteTallyHint {
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
    max-width: 160px;
    margin: 0 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .voteTallyDash {
    color: #dcdfe6;
    font-size: 13px;
  }

  .caseDetailWrap {
    min-height: 160px;
  }
  .caseDetailEmpty {
    padding: 32px;
    text-align: center;
    color: #909399;
    font-size: 13px;
  }
  .caseDetailBody {
    max-height: 72vh;
    overflow: auto;
    padding-right: 2px;
  }

  .cd-summary {
    background: linear-gradient(135deg, #f8fafc 0%, #f3f6fb 100%);
    border: 1px solid #e8ecf2;
    border-radius: 10px;
    padding: 14px 16px;
    margin-bottom: 12px;
  }
  .cd-summaryTop {
    display: flex;
    gap: 12px;
    align-items: flex-start;
  }
  .cd-summaryImg {
    width: 72px;
    height: 72px;
    border-radius: 8px;
    border: 1px solid #ebeef5;
    flex-shrink: 0;
  }
  .cd-summaryImg--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #c0c4cc;
    background: #fff;
  }
  .cd-summaryMain {
    flex: 1;
    min-width: 0;
  }
  .cd-summaryTitleRow {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 6px;
  }
  .cd-summaryTitle {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
    flex: 1;
    min-width: 0;
    word-break: break-word;
  }
  .cd-summarySub {
    font-size: 12px;
    color: #909399;
    margin-bottom: 8px;
  }
  .cd-summaryChips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .cd-chip {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 4px;
    background: #fff;
    color: #606266;
    border: 1px solid #e4e7ed;
  }
  .cd-chip--warn {
    color: #e6a23c;
    border-color: #f5dab1;
    background: #fdf6ec;
  }
  .cd-summaryParties {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 14px;
    padding-top: 12px;
    border-top: 1px dashed #e4e7ed;
  }
  .cd-party {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
  }
  .cd-party--buyer {
    justify-content: flex-end;
  }
  .cd-party--seller {
    justify-content: flex-start;
  }
  .cd-partyAvatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid #ebeef5;
    flex-shrink: 0;
  }
  .cd-partyAvatar--ph {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #e4e7ed;
    color: #909399;
    font-size: 12px;
  }
  .cd-partyName {
    font-size: 13px;
    font-weight: 500;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .cd-vs {
    font-size: 11px;
    color: #c0c4cc;
    font-weight: 600;
    flex-shrink: 0;
  }
  .cd-summaryFoot {
    margin-top: 10px;
    font-size: 12px;
    color: #909399;
    text-align: center;
  }
  .cd-dot {
    margin: 0 4px;
    color: #dcdfe6;
  }
  .cd-alert {
    margin-bottom: 10px;
  }
  .cd-collapse {
    border: none;
    ::v-deep .el-collapse-item__header {
      height: 44px;
      line-height: 44px;
      font-size: 14px;
      font-weight: 600;
      color: #303133;
      background: #fafbfc;
      border: 1px solid #ebeef5;
      border-radius: 8px;
      padding: 0 12px;
      margin-bottom: 8px;
    }
    ::v-deep .el-collapse-item__wrap {
      border: none;
    }
    ::v-deep .el-collapse-item__content {
      padding: 4px 4px 12px;
    }
    ::v-deep .el-collapse-item {
      margin-bottom: 4px;
    }
  }
  .cd-collapseTitle {
    font-weight: 600;
  }
  .cd-collapseBadge {
    margin-left: 8px;
    font-size: 12px;
    font-weight: 400;
    color: #909399;
  }
  .cd-empty {
    font-size: 13px;
    color: #c0c4cc;
    text-align: center;
    padding: 16px 8px;
  }
  .cd-empty--inline {
    padding: 8px;
    text-align: left;
  }
  .cd-kvGrid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px 16px;
    margin-bottom: 12px;
  }
  .cd-kvGrid--2 {
    grid-template-columns: 1fr 1fr;
  }
  .cd-kv {
    display: flex;
    gap: 8px;
    font-size: 13px;
    line-height: 1.45;
    min-width: 0;
  }
  .cd-kv--full {
    grid-column: 1 / -1;
  }
  .cd-kvLbl {
    color: #909399;
    flex-shrink: 0;
    min-width: 56px;
  }
  .cd-kvVal {
    color: #303133;
    flex: 1;
    min-width: 0;
    word-break: break-word;
  }
  .cd-kvVal--emph {
    font-weight: 600;
    color: #e6a23c;
  }
  .cd-kvVal--pre {
    white-space: pre-wrap;
  }
  .cd-subTitle {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
    margin: 4px 0 8px;
    padding-left: 2px;
    border-left: 3px solid #409eff;
  }
  .cd-logiList {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .cd-logiItem {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: #f5f9ff;
    border: 1px solid #e1ecf7;
    border-radius: 6px;
    font-size: 13px;
  }
  .cd-logiItem--return {
    margin-top: 12px;
    background: #fdf6ec;
    border-color: #f5dab1;
  }
  .cd-logiTag {
    font-size: 11px;
    padding: 1px 6px;
    border-radius: 3px;
    background: #409eff;
    color: #fff;
    flex-shrink: 0;
  }
  .cd-logiItem--return .cd-logiTag {
    background: #e6a23c;
  }
  .cd-logiMain {
    color: #303133;
    flex: 1;
    min-width: 0;
    word-break: break-all;
  }
  .cd-logiTime {
    font-size: 12px;
    color: #909399;
    flex-shrink: 0;
  }
  .cd-logiTraceBtn {
    padding: 0 4px;
    flex-shrink: 0;
  }
  .cd-traceWrap {
    min-height: 120px;
    max-height: 420px;
    overflow-y: auto;
  }
  .cd-traceHd {
    margin-bottom: 12px;
    padding: 10px 12px;
    background: #f5f7fa;
    border-radius: 6px;
    font-size: 13px;
  }
  .cd-traceRow {
    display: flex;
    gap: 8px;
    line-height: 1.6;
  }
  .cd-traceRow + .cd-traceRow {
    margin-top: 4px;
  }
  .cd-traceLbl {
    color: #909399;
    flex-shrink: 0;
    width: 36px;
  }
  .cd-traceVal {
    color: #303133;
    word-break: break-all;
  }
  .cd-traceTimeline {
    padding-left: 4px;
  }
  .cd-block {
    padding: 10px 0;
  }
  .cd-block--divider {
    border-top: 1px dashed #ebeef5;
    margin-top: 4px;
    padding-top: 14px;
  }
  .cd-blockHd {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }
  .cd-blockTag {
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 600;
  }
  .cd-blockTag--buyer {
    background: #ecf5ff;
    color: #409eff;
  }
  .cd-blockTag--seller {
    background: #fdf6ec;
    color: #e6a23c;
  }
  .cd-blockTime {
    font-size: 12px;
    color: #909399;
  }
  .cd-imgs {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
  }
  .cd-thumb {
    width: 64px;
    height: 64px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
  }
  .cd-timeline {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .cd-tlItem {
    padding: 10px 12px;
    border-left: 3px solid #dcdfe6;
    background: #fafafa;
    border-radius: 0 6px 6px 0;
  }
  .cd-tlHd {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
    flex-wrap: wrap;
  }
  .cd-tlType {
    font-size: 11px;
    padding: 1px 6px;
    border-radius: 3px;
    font-weight: 600;
  }
  .cd-tlType--claim {
    background: #ecf5ff;
    color: #409eff;
  }
  .cd-tlType--sub {
    background: #f0f9eb;
    color: #67c23a;
  }
  .cd-tlRole {
    font-size: 12px;
    font-weight: 600;
  }
  .cd-tlRole--buyer {
    color: #409eff;
  }
  .cd-tlRole--seller {
    color: #e6a23c;
  }
  .cd-tlTime {
    font-size: 12px;
    color: #909399;
    margin-left: auto;
  }
  .cd-tlClaim {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 4px;
  }
  .cd-tlText {
    font-size: 13px;
    color: #606266;
    line-height: 1.55;
    white-space: pre-wrap;
    word-break: break-word;
  }
  .cd-rulingBox {
    padding: 12px 14px;
    background: #f0f9eb;
    border: 1px solid #e1f3d8;
    border-radius: 8px;
    margin-bottom: 12px;
  }
  .cd-rulingMain {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 6px;
  }
  .cd-rulingWinner {
    color: #67c23a;
  }
  .cd-rulingSep {
    color: #dcdfe6;
    margin: 0 4px;
    font-weight: 400;
  }
  .cd-rulingRemark {
    font-size: 13px;
    color: #606266;
    line-height: 1.5;
    margin-bottom: 6px;
  }
  .cd-rulingMeta {
    font-size: 12px;
    color: #909399;
  }
  .cd-voteBox {
    padding: 10px 0 4px;
  }
  .cd-voteMeta {
    font-size: 12px;
    color: #606266;
    margin-bottom: 10px;
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }
  .cd-urgent {
    color: #f56c6c;
    font-weight: 600;
  }
  .cd-voteStats {
    margin-bottom: 8px;
  }
  .cd-voteHint {
    font-size: 12px;
    color: #606266;
    line-height: 1.45;
    padding: 8px 10px;
    background: #f4f4f5;
    border-radius: 4px;
  }
  .cd-progressList {
    padding-left: 4px;
  }
  .cd-progressItem {
    display: flex;
    gap: 10px;
    padding-bottom: 14px;
    position: relative;
  }
  .cd-progressItem:not(:last-child)::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 14px;
    bottom: 0;
    width: 2px;
    background: #e4e7ed;
  }
  .cd-progressDot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #409eff;
    border: 2px solid #ecf5ff;
    flex-shrink: 0;
    margin-top: 3px;
    z-index: 1;
  }
  .cd-progressBody {
    flex: 1;
    min-width: 0;
  }
  .cd-progressHd {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 4px;
  }
  .cd-progressTitle {
    font-size: 13px;
    font-weight: 600;
    color: #303133;
  }
  .cd-progressRole {
    font-size: 11px;
    color: #909399;
    padding: 0 6px;
    background: #f4f4f5;
    border-radius: 3px;
  }
  .cd-progressTime {
    font-size: 12px;
    color: #c0c4cc;
    margin-left: auto;
  }
  .cd-progressContent {
    font-size: 12px;
    color: #606266;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
  }
  .cd-inspectionBox {
    margin: 12px 0;
    padding: 10px 12px;
    background: #f9fafb;
    border: 1px solid #ebeef5;
    border-radius: 8px;
  }
  .cd-kvVal--bad {
    color: #f56c6c;
    font-weight: 600;
  }
  .cd-reportLink {
    display: inline-block;
    margin-top: 8px;
    font-size: 13px;
    color: #409eff;
  }
}
.appealReviewAlert {
  margin-bottom: 12px;
}
.formHint {
  font-size: 12px;
  color: #909399;
  margin-top: 6px;
  line-height: 1.45;
}
</style>




// WEBPACK FOOTER //
// src/pages/secondhandDispute/index.vue